// extracted by mini-css-extract-plugin
export var commentContainer = "comment-module--commentContainer--Yuwfh";
export var taskContainer = "comment-module--taskContainer--Qw0Zn";
export var task0 = "comment-module--task0--EVdoJ";
export var task1 = "comment-module--task1--U7uyO";
export var task2 = "comment-module--task2--2wVCD";
export var task3 = "comment-module--task3--+ui5J";
export var task4 = "comment-module--task4--VtM-6";
export var taskEdit = "comment-module--taskEdit--9Sum7";
export var taskActivity = "comment-module--taskActivity--DwKDY";